import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import appSettings from 'app/appSettings';
import { RootState } from 'app/store';

export const baseQuery = fetchBaseQuery({
  baseUrl: appSettings.apis.mobileapi.url,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState).userInfo;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

// initialize an empty api service that we'll inject endpoints into later as needed
export const mobileApi = createApi({
  baseQuery,
  reducerPath: 'mobileapi',
  endpoints: () => ({}),
});
